module.exports = __webpack_public_path__ + "img/vision-image.2ab3cf1f.png";